// FNP-536: read-only UsageEvent browse. Two queries, both backed by FNP-594 on
// billing-api. listUsageEvents is Query-backed on record-type-created-index
// (recordType="USAGE_EVENT", newest-first), never a Scan; it returns ALL rows incl.
// unresolvedCustomer/unmetered (the "why didn't this bill?" view).

export const listUsageEvents = `
   query listUsageEvents($filter: UsageEventsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listUsageEvents(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
              id
              eventId
              accountId
              customerId
              meterCode
              quantity
              occurredAt
              receivedAt
              unresolvedCustomer
              unmetered
              recordType
              created
              updated
           }
           nextToken
       }
   }
`;

export const getUsageEvent = `
   query getUsageEvent($id: ID!) {
       getUsageEvent(id: $id) {
         id
         eventId
         accountId
         customerId
         customerMeterKey
         meterCode
         quantity
         occurredAt
         receivedAt
         attributes
         unresolvedCustomer
         unmetered
         recordType
         created
         updated
       }
}`;
